import { ExpenseApi } from "../api";

export class Expense {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
  }
  static async createExpense(formData) {
    const { data } = await ExpenseApi.createExpense(formData);
    return new Expense(data.result);
  }
  static async updateExpense(formData) {
    const { data } = await ExpenseApi.updateExpense(formData);
    return new Expense(data.result);
  }
  static async removeExpense(id) {
    const { data } = await ExpenseApi.removeExpense(id);
    return data.result
  }
  static async getExpense(id) {
    const { data } = await ExpenseApi.getExpense(id);
    return new Expense(data.result);
  }
  static async getExpenseBetweenDateByMarket(formData) {
    const { data } = await ExpenseApi.getExpenseBetweenDateByMarket(formData);
    return data.result.map(item => new Expense(item));
  }
}